export default __webpack_public_path__ + "static/decorist-8-a-059b60d1b75064617c4c3f603313892d.webp";